import { writable, derived } from "svelte/store";
import { DateTime } from "./date-time";
export function parse(value) {
    var _a;
    return ((_a = DateTime.parseOrDefault(value)) === null || _a === void 0 ? void 0 : _a.date) || null;
}
export function format(date, language) {
    var seperator = { de: ".", it: "/", en: "/" }[language] || ".";
    return date ? `${date.day.toString().padStart(2, "0")}${seperator}${date.month.toString().padStart(2, "0")}${seperator}${date.year}` : "";
}
export function inputChanges(inputFrom, inputTo, language) {
    const fromChanges = inputValueChanges(inputFrom, language, "from");
    const toChanges = inputValueChanges(inputTo, language, "to");
    const changes = derived([fromChanges, toChanges], ([from, to], set) => {
        // wait until all inputs are initialized before emiting values
        if (fromChanges.initialized && toChanges.initialized)
            set([from, to]);
    }, [null, null]);
    function setFrom(value, updateInput) {
        var _a;
        if (((_a = fromChanges.date) === null || _a === void 0 ? void 0 : _a.ticks) !== (value === null || value === void 0 ? void 0 : value.ticks)) {
            fromChanges.set(value, updateInput);
            return updateInput;
        }
        fromChanges.initialized = true;
        return false;
    }
    function setTo(value, updateInput) {
        var _a;
        if (((_a = toChanges.date) === null || _a === void 0 ? void 0 : _a.ticks) !== (value === null || value === void 0 ? void 0 : value.ticks)) {
            toChanges.set(value, updateInput);
            return updateInput;
        }
        toChanges.initialized = true;
        return false;
    }
    return {
        subscribe: changes.subscribe,
        set(from, to) {
            fromChanges.initialized = false;
            toChanges.initialized = false;
            try {
                // prevent updating inputs while user is editing
                const updateInputs = (!fromChanges.manualEdit && !toChanges.manualEdit);
                return {
                    from: setFrom(from, updateInputs),
                    to: setTo(to, updateInputs)
                };
            }
            finally {
                fromChanges.manualEdit = false;
                toChanges.manualEdit = false;
            }
        }
    };
}
export function inputValueChanges(input, language, name) {
    const $value = writable(null, (set) => {
        let isUserEditing = false;
        let oldValue = '';
        function update() {
            if (input.value !== store.value && !isUserEditing) {
                store.value = input.value;
                store.date = parse(input.value);
                store.initialized = true;
                set(store.date);
            }
        }
        function onChange() {
            store.manualEdit = false;
            update();
        }
        function onFocus() {
            isUserEditing = true;
            oldValue = input.value;
        }
        function onBlur() {
            if (isUserEditing) {
                isUserEditing = false;
                if (input.value !== oldValue) {
                    oldValue = input.value;
                    store.manualEdit = true;
                    update();
                }
            }
        }
        {
            input.addEventListener("change", onChange);
            input.addEventListener("input", onChange);
            input.addEventListener("focus", onFocus);
            input.addEventListener("blur", onBlur);
            onChange();
        }
        return function stop() {
            input.removeEventListener("change", onChange);
            input.removeEventListener("input", onChange);
            input.removeEventListener("focus", onFocus);
            input.removeEventListener("blur", onBlur);
        };
    });
    const store = {
        /**
         * subscribe for change events
         */
        subscribe: $value.subscribe,
        /**
         * set input value without triggering change events
         */
        set(date, updateInput) {
            const value = format(date, language);
            // update input value
            if (input.value !== value && updateInput) {
                input.value = value;
            }
            console.log('update ' + name + ' value:', `'${value}'`, { updateInput });
            store.value = value;
            store.date = date;
            store.initialized = true;
            store.manualEdit = false;
            $value.set(store.date);
        },
        /**
         * actual value - parsed as DateTime
         */
        date: undefined,
        /**
         * actual input value
         */
        value: undefined,
        /**
         * indicates if the store reflects the actual value of the input
         */
        initialized: false,
        /**
         * indicates if a user changed manualy the input value
         */
        manualEdit: false,
    };
    return store;
}
